// ./types/organizationJsonTypes.ts
import { z } from "zod";

// Define data sharing options enum
export enum EnableSharing {
  DoNotShareMyData = "DoNotShareMyData",
  ShareMyDataButItMustBeAnonymized = "ShareMyDataButItMustBeAnonymized",
  ShareMyDataFully = "ShareMyDataFully",
}

export const dataSharingSchema = z.object({
  enableSharing: z
    .nativeEnum(EnableSharing)
    .default(EnableSharing.DoNotShareMyData),
  shareIfMonetizable: z.boolean().default(false),
});
export type DataSharing = z.infer<typeof dataSharingSchema>;

export const settingsSchema = z.object({
  hideAdvancedGraphs: z.boolean().default(false),
  isPublic: z.boolean(),
  logoUrl: z.string(),
  luckyOrangeSiteId: z.string(),
  projectMilestoneRecipients: z.array(z.string()),
  qgisUrl: z.string(),
  salesforceUrl: z.string(),
  slackXbobToken: z.string(),
});
export type Settings = z.infer<typeof settingsSchema>;

export const googleIntegrationSchema = z.object({
  checklistTemplateId: z.string(),
  googleDriveClientEmail: z.string(),
  googleDrivePrivateKey: z.string(),
  projectMilestoneDatesId: z.string(),
  serviceRequestTemplateId: z.string(),
  useEcosuite: z.boolean().default(false),
});
export type GoogleIntegration = z.infer<typeof googleIntegrationSchema>;

export const softLedgerSchema = z.object({
  clientId: z.string(),
  clientSecret: z.string(),
  tenantUUID: z.string(),
});
export type SoftLedger = z.infer<typeof softLedgerSchema>;

export const solarNetworkCredentialSchema = z.array(
  z.object({
    alias: z.string(),
    host: z.string(),
    secret: z.string(),
    sshHost: z.string(),
    token: z.string(),
    wssHost: z.string(),
  }),
);
export type SolarNetworkCredential = z.infer<
  typeof solarNetworkCredentialSchema
>;
